import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { excludeChildrenByType, findChildByType } from '@fiverr-private/ui_utils';
import { useCollapsibleContext } from '../CollapsibleContext';
import { CollapsibleHeaderProps } from '../types';

const CollapsibleHeader = ({
  children,
  color = 'grey_900',
  fontSize = 'b_md',
  paddingX = '0',
  paddingY = '4',
  onClick,
  textProps = {},
  ...restProps
}: CollapsibleHeaderProps) => {
  const { toggleExpanded, expanded, disabled } = useCollapsibleContext();
  const headerColor = disabled ? 'grey_600' : color;
  const collapsibleChevron = findChildByType(children, 'CollapsibleHeaderChevron');
  const collapsibleHeaderMenu = findChildByType(children, 'CollapsibleHeaderMenu');
  const clickEvent = (e) => {
    toggleExpanded();
    onClick?.(e);
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      clickEvent(e);
    }
  };
  return (
    <Container
      role="button"
      display="flex"
      cursor="pointer"
      aria-expanded={expanded}
      onClick={clickEvent}
      paddingX={paddingX}
      paddingY={paddingY}
      color={headerColor}
      tabIndex={disabled ? -1 : 0}
      outlineColor={{
        focusVisible: 'grey_1200',
      }}
      outlineWidth={{
        focusVisible: 'md',
      }}
      outlineStyle={{
        focusVisible: 'solid',
      }}
      outlineOffset={{ focusVisible: 'sm' }}
      onKeyDown={handleKeyDown}
      {...restProps}
    >
      <Typography as="span" flexGrow={1} fontWeight="bold" fontSize={fontSize} {...textProps}>
        {excludeChildrenByType(children, ['CollapsibleHeaderChevron', 'CollapsibleHeaderMenu'])}
      </Typography>
      <Stack gap="2">
        {collapsibleHeaderMenu}
        {collapsibleChevron}
      </Stack>
    </Container>
  );
};

CollapsibleHeader.displayName = 'CollapsibleHeader';

export default CollapsibleHeader;
